import { render, staticRenderFns } from "./space-file-node.vue?vue&type=template&id=4683e076&"
import script from "./space-file-node.vue?vue&type=script&lang=ts&"
export * from "./space-file-node.vue?vue&type=script&lang=ts&"
import style0 from "./space-file-node.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports